import { render, staticRenderFns } from "./Revenda.vue?vue&type=template&id=7046695c&scoped=true"
import script from "./Revenda.vue?vue&type=script&lang=js"
export * from "./Revenda.vue?vue&type=script&lang=js"
import style0 from "./Revenda.vue?vue&type=style&index=0&id=7046695c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7046695c",
  null
  
)

export default component.exports